import BlockFormatNormalizationsPluginFactory from '../Blocks/BlockFormatNormalizationsPluginFactory';

export const H1NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h1');

export const H2NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h2');

export const H3NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h3');

export const H4NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h4');

export const H5NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h5');

export const H6NormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('h6');

const HeadersNormalizationsPlugin = [
  H1NormalizationPlugin,
  H2NormalizationPlugin,
  H3NormalizationPlugin,
  H4NormalizationPlugin,
  H5NormalizationPlugin,
  H6NormalizationPlugin,
];

export default HeadersNormalizationsPlugin;
